import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  standalone: false
})
export class LoadingComponent {
  isLoading$!: Observable<boolean>;
  constructor(private loadingService: LoadingService) {
    this.isLoading$ = this.loadingService.isLoading;
  }
}
